import { z } from 'zod';
import { ErrorCode } from '../../../../shared/error-codes';
import { PartnerMaterialAdminSchema } from '../../entities/partner-material/partner-material.schema';
/**
 * Confirm Partner Material Upload Request
 * POST /api/v2/admin/partner-materials/:id/files/:locale
 *
 * Replaces the file already stored for that language.
 */ export const ConfirmPartnerMaterialUploadRequestSchema = z.object({
    key: z.string().min(1, ErrorCode.FIELD_REQUIRED),
    fileName: z.string().trim().min(1, ErrorCode.FIELD_REQUIRED)
});
export const ConfirmPartnerMaterialUploadResponseSchema = z.object({
    data: PartnerMaterialAdminSchema
});

//# sourceMappingURL=confirm-partner-material-upload.schema.js.map